<template>
    <div id="loan-simulator">
        <!--=====================================-->
        <!--=        Counter Up Area Start      =-->
        <!--=====================================-->
        <section class="section">
            <div class="container">
                <div class="section-heading">
                    <span class="subtitle primary">Simulador</span>
                    <h2 class="title">Simulemos tu <span class="bold">crédito.</span></h2>
                </div>
                <div v-if="simulationStep == 0" class="row justify-content-center">
                    <div class="col-sm-12 col-md-10 col-lg-8 p-lg-5 p-md-5 p-sm-2 p-5 simulator-border">
                        <div class="row">
                            <div class="col-12 mb--30">
                                <h6 class="mb-0">Crédito <span color="primary">{{ currentProduct }}</span>.</h6>
                            </div>
                            <div class="col-12 mb--30">
                                <label for="person_type" class="bold mb-3">Escoge tu régimen fiscal</label>
                                <select name="person_type" class="form-select" v-model.lazy="personType"
                                    @change="loanMoney = calculateLoanRange[0]">
                                    <option v-if="currentStep != 'forBusinessPage'" :value="0">Persona Física</option>
                                    <option :value="1">Persona Física con Actividad Empresarial</option>
                                    <option v-if="currentStep != 'forPersonalPage'" :value="2">Persona Moral</option>
                                </select>
                            </div>
                            <div class="col-12 mb--20">
                                <label for="person_type" class="bold mb-3">¿Cuánto dinero necesitas para tu
                                    proyecto?</label>
                                <div class="row">
                                    <div class="col-md-3 mb--30 col-sm-12">
                                        <input disabled v-model="loanMoneyText" type="input"
                                            class="custom-input form-range custom-range" color="primary"
                                            id="customRange1">
                                    </div>
                                    <div class="col-md-9 col-sm-12 mb--30">
                                        <input v-model="loanMoney" type="range" class="form-range custom-range"
                                            color="primary" :min="calculateLoanRange[0]" step="10000"
                                            :max="calculateLoanRange[1]" id="customRange1">
                                        <div class="range-tags">
                                            <small class="bold">{{ explicitMoneyFormat(calculateLoanRange[0]) }}</small>
                                            <small class="bold">{{ explicitMoneyFormat(calculateLoanRange[1]) }}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 mb--50">
                                <label for="person_type" class="bold mb-3">Escoge tu plazo</label>
                                <div v-if="!isProductsPage" class="row justify-content-center" id="term">
                                    <div :key="index" v-for="(t, index) in currentTerm" class="col-6 col-md-2 col-lg-2 mb-3">
                                        <input v-model="term" type="radio" class="btn-check" name="options-base"
                                            :id="`option${t}`" :value="t" autocomplete="off">
                                        <label class="btn" :for="`option${t}`">{{ t }} {{ t > 1 ? 'años' : 'año' }}</label>
                                    </div>
                                </div>
                                <div v-else class="row justify-content-center" id="term">
                                    <div class="col-md-3 mb--30 col-sm-12">
                                        <h4>{{ term }} año(s)</h4>
                                    </div>
                                    <div class="col-md-9 col-sm-12 mb--30">
                                        <input v-model="term" type="range" class="form-range custom-range"
                                            color="primary" :min="currentTerm[0]" step="1"
                                            :max="currentTerm[currentTerm.length-1]" id="customRange1">
                                        <div class="range-tags">
                                            <small class="bold">{{ currentTerm[0] }} año</small>
                                            <small class="bold">{{ currentTerm[currentTerm.length-1] }} años</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="errorMssg != null" class="col-12">
                                <div class="alert alert-danger" role="alert">
                                {{ errorMssg }}
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="col-12 btn-center">
                                <button :disabled="isSimulating" @click.stop="simulateHandler()" class="axil-btn rg-btn-dark rg-style-button"
                                    type="border">
                                    Simular
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else-if="simulationStep == 1" class="row justify-content-center">
                    <div class="col-sm-12 col-md-10 col-lg-8 p-lg-5 p-md-5 p-sm-2 p-5 simulator-border btn-center">
                        <h5 class="mb-0">Tu simulación está lista</h5>
                        <p class="mb-0">Compártenos tus datos para enviarte por correo electrónico los datos de tu
                            simulación.</p>

                        <div class="row">
                            <div class="col-12">
                                <startTodayCard id="leadForm"
                                    ref="leadForm"
                                    @updated="showResults"
                                    @reset="resetSimulation" 
                                    :urlPath="'registerApplicant'"
                                    :originLanding="currentProduct"
                                    :lastEmail="applicantEmail"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else-if="simulationStep == 2" class="row justify-content-center">
                    <div class="col-sm-12 col-md-10 col-lg-8 p-lg-5 p-md-5 p-sm-2 p-5 simulator-border btn-center">
                        <h5 class="mb-0">Resultados de tu simulación</h5>
                        <p class="mb-5">Te enviaremos los resultados al correo {{ applicantEmail }}.</p>

                        <div class="row text-start">
                            <div class="col-12 mb-3">
                                <h5 class="mb-2">Detalle del crédito</h5>
                                <div class="flex justify-content-between border-btm mb-2">
                                    <h6 class="mb-2">
                                        Monto solicitado
                                    </h6>
                                    <h6 class="mb-2">
                                        {{ explicitMoneyFormat(simulation.financed_amount, 0) }}
                                    </h6>
                                </div>
                                <div class="flex justify-content-between border-btm mb-2">
                                    <h6 class="mb-2">
                                        Comisión de pre-originación
                                    </h6>
                                    <h6 class="mb-2">
                                        {{ explicitMoneyFormat(simulation.applicant_fee_1, 0) }}
                                    </h6>
                                </div>
                                <div class="flex justify-content-between border-btm mb-2">
                                    <h6 class="mb-2">
                                        Comisión de contratación
                                    </h6>
                                    <h6 class="mb-2">
                                        {{ explicitMoneyFormat(simulation.applicant_fee_2, 0) }}
                                    </h6>
                                </div>
                                <div class="flex justify-content-between border-btm mb-2">
                                    <h6 class="mb-2">
                                        Total a recibir
                                    </h6>
                                    <h6 class="mb-2">
                                        {{ explicitMoneyFormat(simulation.credit_disposal_amount, 0) }}
                                    </h6>
                                </div>
                            </div>
                            <div class="col-12 mb-3">
                                <h5 class="mb-2">Condiciones</h5>
                                <div class="flex justify-content-between border-btm mb-2">
                                    <h6 class="mb-2">
                                        Plazo
                                    </h6>
                                    <h6 class="mb-2">
                                        {{ simulation.term / 12 }} años
                                    </h6>
                                </div>
                                <div class="flex justify-content-between border-btm mb-2">
                                    <h6 class="mb-2">
                                        Mensualidad
                                    </h6>
                                    <h6 class="mb-2">
                                        {{ explicitMoneyFormat(simulation.monthly_payment, 0) }}
                                    </h6>
                                </div>
                                <div class="flex justify-content-between border-btm mb-2">
                                    <h6 class="mb-2">
                                        Tasa anual
                                    </h6>
                                    <h6 class="mb-2">
                                        {{ (simulation.annual_interest_percentage * 100).toFixed(2) }} %
                                    </h6>
                                </div>
                                <!-- <div class="flex justify-content-between border-btm mb-2">
                                    <h6 class="mb-2">
                                        Comisión por manejo de cuenta
                                    </h6>
                                    <h6 class="mb-2">
                                        % mensual
                                    </h6>
                                </div> -->
                            </div>
                            <div class="col-12 mb-5">
                                <div class="accordion" id="rg-accordion">
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="headingOneTable">
                                            <button class="accordion-button btn-success" type="button" data-bs-toggle="collapse"
                                                data-bs-target="#amortization-table" aria-expanded="false"
                                                aria-controls="amortization-table">
                                                <h5 class="mb-0">Tabla de amortización</h5>
                                            </button>
                                        </h2>
                                        <div id="amortization-table" class="accordion-collapse collapse"
                                            aria-labelledby="headingOneTable" data-bs-parent="#rg-accordion">
                                            <div class="accordion-body overflow-auto">
                                                <table class="table table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">Mes</th>
                                                            <th scope="col">Saldo</th>
                                                            <th scope="col">Pago a capital</th>
                                                            <th scope="col">Pago a intereses</th>
                                                            <th scope="col">Pago a comisión</th>
                                                            <th scope="col">IVA de interés y comisión</th>
                                                            <th scope="col">Monto a pagar</th>
                                                            <th scope="col">Saldo final</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(tr, index) in amortization" :key="index">
                                                            <td>{{ tr.number }}</td>
                                                            <td>{{ explicitMoneyFormat(tr.initial_debt) }}</td>
                                                            <td>{{ explicitMoneyFormat(tr.amortization) }}</td>
                                                            <td>{{ explicitMoneyFormat(tr.interest) }}</td>
                                                            <td>{{ explicitMoneyFormat(tr.client_comission) }}</td>
                                                            <td>{{ explicitMoneyFormat(tr.tax + tr.client_commission_tax) }}</td>
                                                            <td>{{ explicitMoneyFormat(tr.cash_payment) }}</td>
                                                            <td>{{ explicitMoneyFormat(tr.final_debt) }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td class="bold">Total</td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td class="bold">{{ explicitMoneyFormat(getTotalCashPayment) }}</td>
                                                            <td></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="row justify-content-center mb-0">
                                    <div class="col-12 btn-center">
                                        <button @click.stop="handleRegisterLink()"
                                            class="axil-btn rg-btn-dark rg-style-button mb-4" type="border">
                                            Iniciar solicitud
                                        </button>
                                        <h6 @click.stop="resetSimulation()" class="mb-0 clickable">Iniciar otra
                                            simulación</h6>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 mt-5">
                                <div class="row justify-content-center mb-0">
                                    <div class="col-12 btn-center">
                                        <small>*Este simulador solo tiene fines ilustrativos. El monto y la tasa de tu crédito pueden variar.</small>
                                        <br>
                                        <small><strong>**CAT {{ decimalsFormat(simulation.cat) }}% sin IVA para fines de esta simulación.</strong></small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import startTodayCard from '../partials/start-today-card.vue';
import formatHelper from "@mixins/formatHelper.js"
export default {
    name: "LoanSimulator",
    mixins: [formatHelper],
    data: () => ({
        simulationStep: 0,
        personType: 0,
        loanMoney: 0,
        loanMoneyText: "",
        term: null,
        simulation: null,
        amortization: null,
        isSimulating: false,
        errorMssg: null,
        applicantEmail: null,
        applicantName: null,
        financeProductId: null,
        cat: null,
        loanLimits: null,
        termOptions: [1, 2, 3, 4, 5],
    }),
    components: {
        startTodayCard
    },
    props: {
        source: String
    },
    async mounted() {
        this.loanLimits = await this.getLoanLimits();
        this.loanMoney = this.calculateLoanRange[0];
        this.loanMoneyText = this.explicitMoneyFormat(this.loanMoney);
        this.cat = await this.getCATText(this.currentLoanType);
        this.termOptions = await this.getLoanTerms();

        this.term = this.isProductsPage ? 1 : null;

    },
    watch: {
        loanMoney() {
            this.loanMoneyText = this.explicitMoneyFormat(this.loanMoney);
        }
    },
    computed: {
        getTotalCashPayment() {
            return this.amortization.reduce((acc, curr) => acc + curr.cash_payment, 0);
        },
        calculateLoanRange() {
            let range = [this.loanLimits.min_limit, this.loanLimits.max_limit_pf];
            if (this.personType == 1 || this.personType == 2) {
                range =  [this.loanLimits.min_limit, this.loanLimits.max_limit_pm];
            }
            return range;
        },
        currentStep() {
            return this.$route.name;
        },
        currentProduct() {
            let product = "Personal";
            if (this.currentStep == "forProductsPage") {
                product = "Ecotecnologías";
            } else if (this.currentStep == "forBusinessPage") {
                product = "PYME";
            } else if (this.currentStep == "forPersonalPage") {
                product = "Personal";
            }

            return product;
        },
        currentTerm() {
            let terms = [];
            const current = this.termOptions.find(x => x.loan_type_id == this.currentLoanType || x.financial_product_id == this.currentFinanceProductId);

            if (current) {
                terms = current.terms.map(function(x) {

                    let yearTerm = x/12;
                    if(Number.isInteger(yearTerm)) {
                        return yearTerm;
                    } 
                    
                });
            }

            let filtered = terms.filter(function (el) {
                return el != null;
            });

            return filtered;
        },
        currentLoanType() {
            let product = 4;
            if (this.currentStep == "forProductsPage") {
                product = 1;
            } else if (this.currentStep == "forBusinessPage") {
                product = 4;
            } else if (this.currentStep == "forPersonalPage") {
                product = 5;
            }

            return product;
        },
        currentFinanceProductId() {
            let product = 5;
            if (this.currentStep == "forProductsPage") {
                product = 5;
            } else if (this.currentStep == "forBusinessPage") {
                product = 6;
            } else if (this.currentStep == "forPersonalPage") {
                product = 7;
            }

            return product;
        },
        isProductsPage() {
            return this.currentStep == "forProductsPage";
        },
    },
    methods: {
        showResults(email, name) {
            this.applicantEmail = email;
            this.applicantName = name.toUpperCase();
            this.simulationStep = 2;
            this.sendSimulator();
        },
        resetSimulation() {
            this.simulationStep = 0;
            this.loanMoney = this.calculateLoanRange[0];
            this.loanMoneyText = this.explicitMoneyFormat(this.loanMoney);
            this.personType = 0;
            this.term = null;
            this.isSimulating = false;
        },
        async simulateHandler(ev) {
            this.errorMssg = null;
            this.isSimulating = true;
            if(this.term == null) {
                this.errorMssg = "Es necesario que selecciones el plazo de tu crédito."
                this.isSimulating = false;
                return;
            }
            try {
                let defaultParams = {
                    clientName: null,
                    currency: 'mxn',
                    rate: 0,
                    annualInterestPercentage: 0.1640,
                    financed_interest_percentage: 0,
                    total_cost: this.loanMoney,
                    total_cost_usd: null,
                    delivery_term: 0,
                    deposit_percentage: 0,
                    term: this.term * 12,
                    qualification: 'B+',
                    loan_type: this.currentLoanType,
                    surplus_percentage: 0,
                    capitalPaymentPercentage: 0,
                    spread_portfolio: true,
                    payment_periodicity: 'monthly',
                    crowdfunding_loan_type: 1,
                    capital_paid_at_term: 0,
                    finance_product_id: this.currentFinanceProductId,
                    amortization_type: 'variable'
                }
                const { data } = await this.publicApiPost('/api/loan/finance/simulate', defaultParams);
                this.simulation = data.finance;
                this.amortization = data.amortization;
                this.simulationStep = 1;
                this.isSimulating = false;
            } finally {
                // this.$vs.loading.close();
            }
        },
        async sendSimulator() {
            this.errorMssg = null;
            this.isSimulating = true;
            if(this.term == null) {
                this.errorMssg = "Es necesario que selecciones el plazo de tu crédito."
                this.isSimulating = false;
                return;
            }
            try {
                let defaultParams = {
                    name: this.applicantName,
                    email: this.applicantEmail,
                    currency: 'mxn',
                    rate: 0,
                    annualInterestPercentage: 0.1640,
                    financed_interest_percentage: 0,
                    total_cost: this.loanMoney,
                    total_cost_usd: null,
                    delivery_term: 0,
                    deposit_percentage: 0,
                    term: this.term * 12,
                    qualification: 'B+',
                    loan_type: this.currentLoanType,
                    surplus_percentage: 0,
                    capitalPaymentPercentage: 0,
                    spread_portfolio: true,
                    payment_periodicity: 'monthly',
                    crowdfunding_loan_type: 1,
                    capital_paid_at_term: 0,
                    finance_product_id: this.currentFinanceProductId,
                    amortization_type: 'variable'
                }
                const { data } = await this.publicApiPost('/api/loan/finance/send-pdf', defaultParams);
            } finally {
                // this.$vs.loading.close();
            }
        },
        handleRegisterLink() {
            window.location.href = `${this.AppURL}/registro/solicitante/?simulation=true`;
        }
    }
}
</script>

<style>
.simulator-border {
    border: solid 2px #28de18;
    border-radius: 10px;
}

.custom-input {
    border: solid 1px #28de18;
    border-radius: 5px;
    padding: 1.3rem;
    background-color: #f8f9fa;
    color: #2d2d2dc7;
    font-weight: semibold;
}

#term label {
    border-color: #c2c2c2;
    padding: 1rem;
}

#term .btn-check:checked+.btn,
        .btn.active,
        .btn.show,
        .btn:first-child:active,
        :not(.btn-check)+.btn:active {
            border-color: var(--color-primary);
        }


.btn-center {
    text-align: center;
}

.border-btm {
    border-bottom: solid 1px #28de18;
}

#rg-accordion .accordion-button:not(.collapsed) {
    background-color: transparent
}

#rg-accordion .accordion-button:focus {
    border-color: var(--color-primary);
    box-shadow: 0px 0px 5px 0px rgb(40, 222, 24) !important;
}


</style>